module.exports = __webpack_public_path__ + "img/218-turkey.8a5f0ce1.svg";